import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { useMemo, useEffect, useState } from "preact/hooks"
import { productImagePlaceholder, imageResizer, productTagBuilder } from "../helpers"

export default function Product({ product, key, index }) {
    const [swatches, setSwatches] = useState([])
    const [currentProductSwatchImg, setCurrentProductSwatchImg] = useState("")
    const [showSkus, setShowSkus] = useState(false)
    const [showMobileModal, setShowMobileModal] = useState(false)
    const { format } = useCurrencyFormatting()
    const hasAltImages = useMemo(() => product.alternateImageUrls && product.alternateImageUrls.length > 0, [])
    let hoverClass = "on-hover-img"
    if (!hasAltImages) {
        hoverClass = ""
    }

    const productTag = useMemo(() => productTagBuilder(product.tags1), [])

    useEffect(() => {
        let productCustomFields = product.customFields
        productCustomFields.forEach((customField) => {
            if (customField.key == "custom-collection_color_swatch_image") {
                const SHOPIFY_STOREFRONT_ACCESS_TOKEN = "cd891bf7a144ebb793436e0e3f308b2b"
                const SHOPIFY_STORE_URL = "https://gruntstyle.myshopify.com/"

                const graphqlQuery = `
                    query {
                    node(id: ${JSON.stringify(customField.value)}) {
                        ... on MediaImage {
                        id
                        image {
                            originalSrc
                            altText
                            width
                            height
                        }
                        }
                    }
                    }
                `

                const fetchOptions = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_ACCESS_TOKEN
                    },
                    body: JSON.stringify({ query: graphqlQuery })
                }

                async function fetchShopifyData() {
                    try {
                        const response = await fetch(`${SHOPIFY_STORE_URL}api/2023-07/graphql.json`, fetchOptions)
                        // console.log('Response status:', response.status);

                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`)
                        }

                        const data = await response.json()
                        // console.log('Response data:', JSON.stringify(data, null, 2));

                        if (data.data && data.data.node) {
                            // console.log("new query data", data);
                            const mediaImage = data.data.node
                            setCurrentProductSwatchImg(mediaImage.image.originalSrc)
                        }
                    } catch (error) {
                        console.error("Error fetching data:", error.message)
                    }
                }
                fetchShopifyData()
            }
        })
    }, [])

    useEffect(() => {
        let swatchImgsArray = []

        // check if the product has any custom fields for the img and make the needed query
        // for each product, we automatically make a query that returns it's custom fields
        const query = `
            query {
                product(id: ${JSON.stringify(product.productId)}) {
                    attributes {
                        key
                        value
                    }
                }
            }
        `

        let productCustomFields
        fetch("https://api.nosto.com/v1/graphql", {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/graphql",
                Authorization: "Basic " + btoa(":" + "jR7vp6dbT1G9oTCYIrkAT29zUusVWoVLPAw1DNDcDJmRhNkyBMevUSVNxjtrZiYh")
            }),
            mode: "cors",
            body: query
        })
            .then((response) => response.json())
            // once we have the custom fields, we then are checking for the field 'custom product swatches',
            // that contains shopify meta objects which also include the nosto product id
            .then((json) => {
                productCustomFields = json
                const productFieldsArray = productCustomFields?.data?.product?.attributes
                let siblingProducts = []
                productFieldsArray.forEach((obj) => {
                    if (obj.key == "custom-product_swatches") {
                        siblingProducts = JSON.parse(obj.value)
                    }
                })
                // with the array of sibling product shopify metaobjects, we turn them into regular product ids and make another query
                siblingProducts.forEach((siblingProduct) => {
                    const productId = siblingProduct.split("gid://shopify/Product/")[1]
                    const query = `
                    query {
                        product(id: ${JSON.stringify(productId)}) {
                            url
                            availability
                            attributes {
                                key
                                value
                            }
                        }
                    }
                `
                    fetch("https://api.nosto.com/v1/graphql", {
                        method: "POST",
                        headers: new Headers({
                            "Content-Type": "application/graphql",
                            Authorization:
                                "Basic " +
                                btoa(":" + "jR7vp6dbT1G9oTCYIrkAT29zUusVWoVLPAw1DNDcDJmRhNkyBMevUSVNxjtrZiYh")
                        }),
                        mode: "cors",
                        body: query
                    })
                        .then((response) => response.json())
                        .then((json) => {
                            let siblingProductCustomFields = json
                            const siblingProductFieldsArray = siblingProductCustomFields?.data?.product?.attributes;
                            const isHasAnImage = siblingProductFieldsArray?.find(field => field?.key === "custom-collection_color_swatch_image")?.value;
                            siblingProductFieldsArray.forEach((sObj) => {
                                if (sObj.key == "custom-collection_color_swatch_image") {
                                    const swatchInfo = {}
                                    swatchInfo.hexValue = false

                                    // make a similar shopify storefront api call in order to find swatchInfo.swatchImgSrc
                                    const SHOPIFY_STOREFRONT_ACCESS_TOKEN = "cd891bf7a144ebb793436e0e3f308b2b"
                                    const SHOPIFY_STORE_URL = "https://gruntstyle.myshopify.com/"

                                    const graphqlQuery = `
                                query {
                                node(id: ${JSON.stringify(sObj.value)}) {
                                    ... on MediaImage {
                                    id
                                    image {
                                        originalSrc
                                        altText
                                        width
                                        height
                                    }
                                    }
                                }
                                }
                            `

                                    const fetchOptions = {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_ACCESS_TOKEN
                                        },
                                        body: JSON.stringify({ query: graphqlQuery })
                                    }

                                    async function fetchShopifyDataB() {
                                        try {
                                            const response = await fetch(
                                                `${SHOPIFY_STORE_URL}api/2023-07/graphql.json`,
                                                fetchOptions
                                            )
                                            // console.log('Response status:', response.status);

                                            if (!response.ok) {
                                                throw new Error(`HTTP error! status: ${response.status}`)
                                            }

                                            const data = await response.json()
                                            // console.log('Response data:', JSON.stringify(data, null, 2));

                                            if (data.data && data.data.node) {
                                                const mediaImage = data.data.node
                                                swatchInfo.swatchImgSrc = mediaImage.image.originalSrc
                                                swatchInfo.productId = productId
                                                swatchInfo.url = siblingProductCustomFields?.data?.product?.url
                                                swatchInfo.path = swatchInfo.url.split("/products/")[1].split("?")[0]
                                                swatchInfo.availability =
                                                    siblingProductCustomFields?.data?.product?.availability
                                                setSwatches((prevSwatches) => [...prevSwatches, swatchInfo])
                                            }
                                        } catch (error) {
                                            console.error("Error fetching data:", error.message)
                                        }
                                    }
                                    fetchShopifyDataB()
                                } else if (!isHasAnImage && sObj.key == "custom-collection_color_swatch_hex_code") {
                                    const swatchInfo = {}
                                    swatchInfo.swatchImgSrc = false
                                    swatchInfo.hexValue = sObj.value
                                    swatchInfo.productId = productId
                                    swatchInfo.url = siblingProductCustomFields?.data?.product?.url
                                    swatchInfo.path = swatchInfo.url.split("/products/")[1].split("?")[0]
                                    swatchInfo.availability = siblingProductCustomFields?.data?.product?.availability
                                    setSwatches((prevSwatches) => [...prevSwatches, swatchInfo])
                                } 
                            })
                        })
                })
            })
    }, [])

    let atLeastOneAvailable = false
    let firstSwatch = true
    let swatchCount = 0

    return (
        <SerpElement
            as="a"
            hit={product}
            class="product-card-item ns-product ns-border-box ns-clickable ns-text-undecorated ns-color-inherit ns-col-12 ns-col-xs-6 ns-col-l-3 ns-p-2 ns-my-2 ns-mx-0"
            onMouseLeave={() => setShowSkus(false)}
        >
            <div class="product-background-enabled product-card">
                <div class={`product-card-img product-img ${hoverClass}`}>
                    <div class="media" style="--imageRatio:100.0%">
                        <img
                            class="ns-w-100 ns-h-auto"
                            src={imageResizer(product.imageUrl, "350") ?? productImagePlaceholder}
                            alt={product.name}
                            width="600"
                            height="400"
                        />
                    </div>
                    {hasAltImages && (
                        <div class="product-second-img">
                            <img
                                class="ns-w-100 ns-h-auto"
                                src={imageResizer(product.alternateImageUrls[0], "350") ?? productImagePlaceholder}
                                alt={product.name}
                                width="600"
                                height="400"
                            />
                        </div>
                    )}
                    {productTag && (
                        <div class="product-card-badges">
                            <span class="product-badge custom-badge fadein-active">{productTag}</span>
                        </div>
                    )}
                    {/* Desktop sizes */}
                    <div class={`ns-skus ${showSkus ? "show-skus" : ""}`}>
                        {product.skus && product.skus.length > 1 && <div class="ns-sku-select-size">Select Size</div>}
                        <div class="ns-sku-buttons">
                            {product.skus &&
                                product.skus.map((sku) => {
                                    let skuSizeCaps = ""

                                    if (product.skus.length > 1) {
                                        const sizeField = sku.customFields.find((field) => field.key === "size")
                                        if (sizeField) {
                                            const skuSizeStr = sizeField.value
                                            if (
                                                [
                                                    "XSmall",
                                                    "Small",
                                                    "Medium",
                                                    "Large",
                                                    "XLarge",
                                                    "2XLarge",
                                                    "3XLarge",
                                                    "4XLarge"
                                                ].includes(skuSizeStr)
                                            ) {
                                                // Extract capital letters and numbers from size string
                                                skuSizeCaps = skuSizeStr
                                                    .split("")
                                                    .filter(
                                                        (char) =>
                                                            (char === char.toUpperCase() &&
                                                                char !== char.toLowerCase()) ||
                                                            !isNaN(char)
                                                    )
                                                    .join("")
                                            } else {
                                                skuSizeCaps = sku.name
                                            }
                                        } else {
                                            skuSizeCaps = sku.name
                                        }
                                    } else {
                                        skuSizeCaps = "Add To Cart"
                                    }

                                    return (
                                        <div
                                            key={sku.id}
                                            class={`product_form_wrapper ${
                                                product.skus.length < 2 ? "ns-single-sku-form" : ""
                                            }`}
                                            data-product-wrapper
                                        >
                                            <div class="pdp-action-wrapper">
                                                <button
                                                    type="button"
                                                    aria-label="Add To Cart Button"
                                                    class={`Rise-add-to-cart-button a2c-btn medium-btn button ${
                                                        sku.availability !== "InStock" ? "ns-disabled" : ""
                                                    } ${product.skus.length < 2 ? "button ns-text-atc" : ""}`}
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        e.stopPropagation()
                                                        Nosto.addSkuToCart({
                                                            productId: product.productId,
                                                            skuId: sku.id
                                                        })
                                                    }}
                                                    data-add-to-cart=""
                                                    data-side-drawer-open=""
                                                    data-dnr-product="false"
                                                >
                                                    <span>{skuSizeCaps}</span>
                                                </button>
                                            </div>
                                        </div>
                                    )
                                })}
                        </div>
                    </div>
                </div>
                <div class="ns-relative product-card-detail" data-nosto-element="product">
                    <div class="swatches-container">
                        {/* this is only for rendering the products current swatch */}
                        {/* {swatches &&
                            swatches.length > 0 &&
                            product?.customFields?.map((customField, index) => {
                                if (customField?.key === "custom-collection_color_swatch_hex_code") {
                                    return (
                                        <span
                                            key={index}
                                            class="collection-swatch-img first-swatch"
                                            style={{ backgroundColor: customField?.value }}
                                            data-swatch=""
                                            href={product.url}
                                            data-quick-add={product.productId}
                                            data-quick-add-handle={product.path}
                                            data-quick-add-item-url=""
                                            role="group"
                                        />
                                    )
                                } else if (customField?.key === "custom-collection_color_swatch_image") {
                                    return (
                                        <button
                                            key={index}
                                            class="collection-swatch-img first-swatch"
                                            data-swatch=""
                                            href={product.url}
                                            data-quick-add={product.productId}
                                            data-quick-add-handle={product.path}
                                            data-quick-add-item-url=""
                                            role="group"
                                        >
                                            <img
                                                // alt={product.path}
                                                src={currentProductSwatchImg}
                                                class="collection-swatch-img"
                                            />
                                        </button>
                                    )
                                }
                                return null
                            })} */}
                            {swatches && swatches.length > 0 && (() => {
                                // Find the image swatch field in customFields
                                const imageField = product?.customFields?.find(
                                    cf => cf?.key === "custom-collection_color_swatch_image"
                                );
                                if (imageField) {
                                    return (
                                        <button
                                            class="collection-swatch-img first-swatch"
                                            data-swatch=""
                                            href={product.url}
                                            data-quick-add={product.productId}
                                            data-quick-add-handle={product.path}
                                            data-quick-add-item-url=""
                                            role="group"
                                        >
                                            <img
                                                src={currentProductSwatchImg}
                                                class="collection-swatch-img"
                                            />
                                        </button>
                                    );
                                }
                                // Fallback to hex code swatch
                                const hexField = product?.customFields?.find(
                                    cf => cf?.key === "custom-collection_color_swatch_hex_code"
                                );
                                if (hexField) {
                                    return (
                                        <span
                                            class="collection-swatch-img first-swatch"
                                            style={{ backgroundColor: hexField?.value }}
                                            data-swatch=""
                                            href={product.url}
                                            data-quick-add={product.productId}
                                            data-quick-add-handle={product.path}
                                            data-quick-add-item-url=""
                                            role="group"
                                        />
                                    );
                                }
                                return null;
                            })()}
                        {swatches &&
                            swatches.length > 0 &&
                            swatches.map((swatch, index) => {
                                // && !swatch.path.includes("pack")
                                if (
                                    swatch.availability == "InStock" &&
                                    swatchCount < 4
                                ) {
                                    swatchCount = swatchCount + 1
                                    if (swatch.swatchImgSrc) {
                                        return (
                                            <button
                                                key={index + 1}
                                                class="collection-swatch-img second-swatch"
                                                data-swatch=""
                                                href={swatch.url}
                                                data-quick-add={swatch.productId}
                                                data-quick-add-handle={swatch.path}
                                                data-quick-add-availability={
                                                    swatch.availability == "InStock" ? "true" : "false"
                                                }
                                                data-quick-add-item-url=""
                                                role="group"
                                            >
                                                <img
                                                    alt={swatch.path}
                                                    src={swatch.swatchImgSrc}
                                                    class="collection-swatch-img second-swatch"
                                                />
                                            </button>
                                        )
                                    }else if (swatch.hexValue) {
                                        return (
                                            <span
                                                key={index + 1}
                                                class="collection-swatch-img second-swatch"
                                                style={{ backgroundColor: swatch.hexValue }}
                                                data-swatch=""
                                                href={swatch.url}
                                                data-quick-add={swatch.productId}
                                                data-quick-add-handle={swatch.path}
                                                data-quick-add-availability={
                                                    swatch.availability == "InStock" ? "true" : "false"
                                                }
                                                data-quick-add-item-url=""
                                                role="group"
                                            ></span>
                                        )
                                    } 
                                }
                                if (swatchCount == 4 && index >= 4) {
                                    swatchCount = swatchCount + 1
                                    return (
                                        <button
                                            key={index + 1}
                                            class="collection-swatch-img extra-swatch"
                                            href={product.url}
                                            role="group"
                                            style="position:relative;"
                                        >
                                            <img
                                                alt="See More"
                                                src="https://d21m4dsqdd3b9h.cloudfront.net/shopify-12583447/onsiteContent/17255008310580.17289873654379884"
                                                class="collection-swatch-img extra-swatch"
                                                style="position:absolute;top:-1px;left:-1px;background:#fff"
                                            />
                                        </button>
                                    )
                                }
                            })}
                    </div>
                    <div class="product-title nosto-product-title">{product.name}</div>
                    <div class="product-price">
                        <span class="price-item actual-price">{format(product.price)}</span>
                        {product.listPrice && product.listPrice > product.price && (
                            <span class="price-item compare-price">{format(product.listPrice)}</span>
                        )}
                    </div>
                    <div class="product-quickview-button">
                        {/* https://nostosolutions.atlassian.net/browse/FEA-12068 */}
                        <a 
                            href={product.url} 
                            data-quick-view-availability="true" 
                            tabindex="-1" 
                            aria-label=" quick view link" 
                            data-quick-view="" 
                            class={`product-quickview button btn-block ${product.availability === 'InStock' ? '' : 'qa-sold-out'}`}
                        >
                            <span>{product.availability === 'InStock' ? 'Quick Add' : 'SOLD OUT'}</span>
                        </a>
                        {/* <div class="ns-quick-view-desktop">
                            {product.availability == "InStock" ? (
                                <button
                                    class="product-quickview button btn-block"
                                    tabindex="-1"
                                    aria-label="quick view link"
                                    onMouseEnter={() => product.skus.length > 1 && setShowSkus(true)}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        if (product.skus.length === 1) {
                                            Nosto.addSkuToCart({
                                                productId: product.productId,
                                                skuId: product.skus[0].id
                                            })
                                        }
                                    }}
                                >
                                    <span>Quick Add</span>
                                </button>
                            ) : (
                                <button
                                    class="product-quickview button btn-block qa-sold-out"
                                    tabindex="-1"
                                    aria-label="quick view link"
                                >
                                    <span>SOLD OUT</span>
                                </button>
                            )}
                        </div>
                        <div class="ns-quick-view-mobile">
                            {product.availability == "InStock" ? (
                                <button
                                    class="product-quickview button btn-block"
                                    tabindex="-1"
                                    aria-label="quick view link"
                                    pid={product.productId}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        if (product.skus.length === 1) {
                                            Nosto.addSkuToCart({
                                                productId: product.productId,
                                                skuId: product.skus[0].id
                                            })
                                        } else {
                                            setShowMobileModal(true)
                                        }
                                    }}
                                >
                                    <span>Quick Add</span>
                                </button>
                            ) : (
                                <button
                                    class="product-quickview button btn-block qa-sold-out"
                                    tabindex="-1"
                                    aria-label="quick view link"
                                >
                                    <span>SOLD OUT</span>
                                </button>
                            )}
                        </div> */}
                    </div>
                </div>
            </div>
            <div
                class={`ns-skus ns-mobile-modal mobile-wrapper-${product.productId}`}
                style={{ display: showMobileModal ? "block" : "none" }}
            >
                {product.skus && product.skus.length > 1 && (
                    <>
                        <div class="ns-modal-backdrop" onClick={() => setShowMobileModal(false)}></div>
                        <div class="ns-skus-container">
                            <button
                                class="ns-quick-view-close"
                                data-close-target=""
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    setShowMobileModal(false)
                                }}
                            >
                                <svg
                                    width="16"
                                    height="15"
                                    viewBox="0 0 16 15"
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="icon-close"
                                >
                                    <path d="M1.135.372.791.717l.64.661L4.69 4.757l2.618 2.717-.341.35c-.788.805-5.941 6.159-5.949 6.18-.005.013.146.181.335.374l.345.35 3.14-3.258c1.727-1.791 3.149-3.257 3.161-3.257.022 0 .193.176 3.786 3.903l2.515 2.61.344-.343c.189-.189.341-.356.337-.372-.007-.025-5.081-5.303-5.974-6.214l-.317-.323 2.233-2.317c1.229-1.274 2.695-2.795 3.26-3.379L15.209.716l-.344-.345a4.706 4.706 0 0 0-.364-.344c-.01 0-1.474 1.509-3.253 3.353a472.525 472.525 0 0 1-3.249 3.353c-.008 0-1.47-1.509-3.249-3.353A392.825 392.825 0 0 0 1.498.027c-.01 0-.174.155-.363.345"></path>
                                </svg>
                            </button>
                            <div class="ns-sku-select-size">Select Size</div>
                            <div class="ns-sku-buttons">
                                {product.skus &&
                                    product.skus.map((sku) => {
                                        let skuSizeCaps = ""

                                        const sizeField = sku.customFields.find((field) => field.key === "size")
                                        if (sizeField) {
                                            const skuSizeStr = sizeField.value
                                            if (
                                                [
                                                    "XSmall",
                                                    "Small",
                                                    "Medium",
                                                    "Large",
                                                    "XLarge",
                                                    "2XLarge",
                                                    "3XLarge",
                                                    "4XLarge"
                                                ].includes(skuSizeStr)
                                            ) {
                                                // Extract capital letters and numbers from size string
                                                skuSizeCaps = skuSizeStr
                                                    .split("")
                                                    .filter(
                                                        (char) =>
                                                            (char === char.toUpperCase() &&
                                                                char !== char.toLowerCase()) ||
                                                            !isNaN(char)
                                                    )
                                                    .join("")
                                            } else {
                                                skuSizeCaps = sku.name
                                            }
                                        } else {
                                            skuSizeCaps = sku.name
                                        }


                                        return (
                                            <div key={sku.id} class="product_form_wrapper" data-product-wrapper>
                                                <div class="pdp-action-wrapper">
                                                    <button
                                                        type="button"
                                                        aria-label="Add To Cart Button"
                                                        class={`Rise-add-to-cart-button a2c-btn medium-btn button ${
                                                            sku.availability !== "InStock" ? "ns-disabled" : ""
                                                        }`}
                                                        data-add-to-cart=""
                                                        data-side-drawer-open=""
                                                        data-dnr-product="false"
                                                        disabled={sku.availability !== "InStock"}
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            e.stopPropagation()
                                                            Nosto.addSkuToCart({
                                                                productId: product.productId,
                                                                skuId: sku.id
                                                            })
                                                            setTimeout(() => {
                                                                setShowMobileModal(false)
                                                            }, 200)
                                                        }}
                                                    >
                                                        <span>{skuSizeCaps}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        )
                                    })}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </SerpElement>
    )
}
